import { useState, useEffect, useRef } from 'react';

import arrowUp from '../svg/Pfeil-nach-oben.svg';

import './NachObenButton.css';

function NachObenButton() {
  const button = useRef<HTMLDivElement | null>(null);

  window.onscroll = function () { scrollFunction(); };

  function scrollFunction() {
    if (button.current !== null) {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        button.current.style.display = 'block';
      } else {
        button.current.style.display = 'none';
      }
    } 
  }

  function scrollToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  return (
    <div className="to-top" ref={button}>
      <button type="button" className="to-top-button" onClick={scrollToTop}>
        { /* <img src={arrowUp} alt="" /> */ }
        <span>nach</span>
        <span>oben</span>
      </button>
    </div>
  );
}

export default NachObenButton;
